import { Document } from '@contentful/rich-text-types';
import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';

export class LiveSupportInformation implements Deserializable<JsonObject, LiveSupportInformation> {
  constructor(
    public title?: string,
    public description?: Document,
    public linkUrl?: string,
    public linkText?: string,
    public email?: string,
    public phoneNumber?: string,
    public hours?: string
  ) {}

  deserialize(input: JsonObject): LiveSupportInformation {
    if (input == null) {
      return null;
    }

    this.title = input['title'];
    this.description = input['description'];
    this.linkUrl = input['linkUrl'];
    this.linkText = input['linkText'];
    this.email = input['email'];
    this.phoneNumber = input['phoneNumber'];
    this.hours = input['hours'];
    return this;
  }
}
